import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PrerenderReset() {
  const location = useLocation();

  useEffect(() => {
    window.__PRERENDER_READY__ = false;
  }, [location.pathname, location.search]);

  return null;
}
